<ng-container>
    @if(isPageRestrictionLoaded){
    <div class="ppl-container-body">
        <div class="ppl-container-head">
            <h1 class="page-title-accessibility">{{source | titlecase}} Approvals</h1>
        </div>
        <div class="ppl-container">
            <div class="ppl-content-container">
                <div class="w-100">
                    <ppl-purchase-filter [pageId]="pageId" (searchEvent)="onSearch($event)">
                    </ppl-purchase-filter>
                    <div>
                        <p><strong>Note:</strong></p>
                        <ul>
                            <li>For <strong>Approve</strong> and <strong>Reject</strong> actions, please select the
                                applicable purchase request.</li>
                            <li>The <strong>Approve All</strong> and <strong>Reject All</strong> actions will update all
                                purchase request that match the search criteria OR all the selected purchase request.</li>
                        </ul>
                    </div>
                </div>
                <div class="table-style">
                    @if (timesheets.length > 0) {
                    <ppl-list-table [cols]="cols" [disableSort]="true" [disableSearch]="true" [showCustomSearch]="false"
                        [data]="timesheets" [customDataLoaded]="true" [enableActions]="true" [from]="'timesheet'"
                        [gridTitle]="false" [pagination]="true" [loadPage]="true" [actionButtons]="actionButtons"
                        [enablePageActions]="!isReadOnly" [timesheetFor]="'pendedTimesheet'"
                        [listButton]="isReadOnly ? [] : buttons" (actionInvoked)="gridAction($event)"
                        (gridAction)="onAction($event)" (onPageLoad)="onPageLoad($event)"
                        (rowCellClicked)="onCellClicked($event)"
                        [onViewUser]="onViewUserClicked">
                    </ppl-list-table>
                    } @else {
                    <div class="alert alert-warning">
                        <strong>No Records Found.</strong> Please change the filters to find the records.
                    </div>
                    }
                </div>
            </div>
        </div>
    </div>
    }
</ng-container>

<ppl-popup-dialog [(isVisible)]="showActionPopup" [title]="title" [showButtons]="false" [showOkButton]="false"
    [showClose]="true" [size]="'medium'" [position]="'center'">
    <div class="p-10">
        <form nz-form nz-row [formGroup]="approvalTimesheetForm" class="ppl-p0 mt-2">
            <table class="table">
                <thead>
                    <tr>
                        <th style="background-color: #a8e4e14d; width: 25%;">{{this.commentText}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>
                            <input formControlName="comments" nz-input id="comments"
                                [nzStatus]="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched ? 'error' : ''" />
                            <div style="margin-left: 8px; margin-right: 8px;width: 100%;"
                                *ngIf="approvalTimesheetForm.get('comments')?.invalid && approvalTimesheetForm.get('comments')?.touched">
                                <div class="error-message">Please add the reject comments.</div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div *ngIf="this.isDialogNoteDisplayed" class="alert alert-warning">
                <strong>{{this.dialogNoteMessage}}</strong>
            </div>
            <div class="custom-row w-100">
                <ppl-button (click)="onSave()" [styleString]="'margin-right: 8px;'" label={{dialogButtonLabel}}
                    icon="fa fa-check-circle" [customClass]="'primary-button'" [iconPosition]="'right'"></ppl-button>
            </div>
        </form>
    </div>
</ppl-popup-dialog>

<div class="filter-panel">
    <ng-template #authDialog let-cancel="cancel">
        <ppl-authorization-details [authorizationId]="selectedAuthorizationId" [pageSource]="'purchaseRequest'" [isReadOnly]="true"></ppl-authorization-details>
    </ng-template>
</div>

<!-- View Purchase Request Dialog -->
<div class="filter-panel">
    <ng-template #viewPurchaseRequestDialog let-cancel="cancel">
        <ppl-create-purchase-request [mode]="mode" [purchaseRequestListData]="viewPurchaseRequestData"
            (cancel)="handleViewPurchaseRequestCancel($event)" [staffView]="true"></ppl-create-purchase-request>
    </ng-template>
</div>

<!-- Original Purchase Request Dialog -->
<div class="filter-panel">
    <ng-template #originalRequestDialog let-cancel="cancel">
        <div class="p-10">
            <p>The list below shows both the original and the adjusted purchase request lines so you can verify what has changed.</p>
            @if (originalRequestLines.length > 0) {
            <ppl-list-table [cols]="originalCols" [disableSort]="true" [disableSearch]="true"
                [showCustomSearch]="false" [data]="originalRequestLines" [customDataLoaded]="true" [customDataHasUnknownTotal]="false"
                [enableActions]="false" [from]="'timesheet'" [gridTitle]="false" [pagination]="false"
                [loadPage]="true">
            </ppl-list-table>
            } @else if (originalRequestLoaded) {
            <div class="alert alert-warning">
                <strong>No original request data found.</strong>
            </div>
            }
        </div>
    </ng-template>
</div>

